import * as React from 'react';
import { N1PublicationBannerContainer } from '../../N1PublicationBanner/N1PublicationBanner.container';
import { MLSNPublicationBannerContainer } from '../../MLSNPublicationBanner/MLSNPublicationBanner.container';
import { VisibleViolationsWarningContainer } from '../../VisibleViolationsWarning';
import { ActionButtonsContainer } from '../../ActionButtons';
import { ServicePickerWidget } from '../../PublishTerms/components/ServicePickerWidget/ServicePickerWidget';

export const SummaryMobileServicePickerWidget = () => {
  return (
    <>
      <ServicePickerWidget />
      <N1PublicationBannerContainer />
      <MLSNPublicationBannerContainer />
      <VisibleViolationsWarningContainer />
      <ActionButtonsContainer />
    </>
  );
};
